module.exports = __webpack_public_path__ + "static/media/drop-off.a38472d4.svg";